import { ModuleDto } from "./moduleDto";

export class TrainingPathTanslationDto {
  id: number;
  title: string;
  description: string;
  supportUrl: string;
  supportPath: string;
  trainingPathDuration: string;
  capacity: string;
  preRequest: string;
  language: string;
  trainingPathID: number;
  moduleList: ModuleDto[];
  addedTemplateText: string;
  offlinePath: string;
}
